import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import { useEffect } from "react";
import axios from "axios";
import { useState } from "react";
import Spinner from "../../../Loading/RoundLoading";
import { toast } from "react-toastify";

export default function Gmailview() {
  // const [value, setValue] = React.useState(0);
  const [loading, setLoading] = useState(false);
  const [mySignatureHtml, setMySignatureHtml] = useState("");

  const getHtml = () => {
    copyToClipboard(mySignatureHtml.html);

    toast.success("Your Signature Copied to Clipboard. ", {
      closeOnClick: true,
      theme: "colored",
    });
  };

  function copyToClipboard(html) {
    var container = document.createElement("div");
    container.innerHTML = html;
    container.style.position = "fixed";
    container.style.pointerEvents = "none";
    container.style.opacity = 0;
    document.body.appendChild(container);
    window.getSelection().removeAllRanges();
    var range = document.createRange();
    range.selectNode(container);
    window.getSelection().addRange(range);
    document.execCommand("copy");
    document.body.removeChild(container);
  }

  const MySignatureHtml = async () => {
    try {
      setLoading(true);
      const response = await axios.get("/getUser");
      const user = response.data.user;
      if (response.data.status === 200) {
        setMySignatureHtml(user.my_signature !== null ? user.my_signature : "");
      } else {
        console.log(response.data);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    MySignatureHtml();
  }, []);

  if (loading) {
    return <Spinner />;
  } else {
    return (
      <>
        <h4 className="mb-4">How do I add my new email signature to Gmail?</h4>
        {mySignatureHtml !== "" ? (
          <ol type="a">
            <li>
              Copy your signature code by clicking
              <button
                style={{ background: "transparent" }}
                className=" border-0 text-info"
                onClick={getHtml}
              >
                Here <FontAwesomeIcon icon={faCopy} />
              </button>
            </li>
            <li>Paste the signature code to use it</li>
          </ol>
        ) : (
          <p>
            Please Select Your Template in Template Settings First to Use
            Signature
          </p>
        )}
      </>
    );
  }
}
